import { rutinInfos } from '../../_Common/Const/RutinInfo';
import { pipe } from 'ramda';
import { withAddStartedRoutine } from '../../../StartPanel/Components/Cards/StartedRoutines/startedRoutineQueries';
import withErrorBoundary from '../../../../hoc/withErrorBoundary';
import AnalysutdelningPage from './Analysutdelning/AnalysutdelningPage';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';
import { useKonteringarOnStartWarningHook } from './Konteringar/Utils/useKonteringarOnStartWarningHook';
import { useBokforderOnStartWarningHook } from './Bokforder/Utils/useBokforderOnStartWarningHook';
import { CustomBfoAddButton } from './Bokforder/Components/CustomBfoAddButton';
import { IRoutine, ShowDetailsRight } from '../../_Common/Const/Delsystem';
import { useEkonomiskAnalysOnStartWarningHook } from './EkonomiskAnalys/Utils/useEkonomiskAnalysOnStartWarningHook';
import BokforderWrapper from './Bokforder/Components/BokforderWrapper';
import useBokforderFunctionMenuItems from './Bokforder/Utils/useBokforderFunctionMenuItems';
import EkonomiskAnalysPage from './EkonomiskAnalys/EkonomiskAnalysPage';
import { useBokforderBusinessCollectionMenuItems } from './Bokforder/Utils/useBokforderBusinessCollectionMenuItems';

const EKRutiner: { [rtnKey: string]: IRoutine } = {
  rtnBudgetVerifikation: {
    component: getStandardRutin(
      rutinInfos.rtnBudgetVerifikation,
      'EKBudgetVer'
    ),
  },
  rtnSpecEkoRapport: {
    component: getStandardRutin(
      rutinInfos.rtnSpecEkoRapport,
      'EKEkonomirapport'
    ),
  },
  rtnEKRapportpaket: {
    component: getStandardRutin(rutinInfos.rtnEKRapportpaket, 'EKRapportpaket'),
  },
  rtnKonteringar: {
    component: getStandardRutin(rutinInfos.rtnKonteringar, 'EKBokfkontering'),
    onStartWarningHook: useKonteringarOnStartWarningHook,
    defaultShowDetailsRight: ShowDetailsRight.DefaultTrue,
  },
  rtnFakturahandelser: {
    component: getStandardRutin(
      rutinInfos.rtnFakturahandelser,
      'EKFakturahandelse'
    ),
  },
  rtnPersonalregister: {
    component: getStandardRutin(rutinInfos.rtnPersonalregister, 'EKPersonal'),
  },
  rtnAutomatkontering: {
    component: getStandardRutin(
      rutinInfos.rtnAutomatkontering,
      'EKAutomatkonteringar'
    ),
  },
  rtnOmfordelning: {
    component: getStandardRutin(
      rutinInfos.rtnOmfordelning,
      'EKAutomatkonteringar'
    ),
  },
  rtnGava: {
    component: getStandardRutin(rutinInfos.rtnGava, 'EKGava'),
  },
  rtnWebBokforder: {
    customAddButton: CustomBfoAddButton,
    component: getStandardRutin(
      rutinInfos.rtnWebBokforder,
      'EKBokforder',
      useBokforderFunctionMenuItems,
      useBokforderBusinessCollectionMenuItems,
      BokforderWrapper
    ),
    detaljVy: 'Bokforder',
    directEditMode: true,
    filterAttributes: [
      { attribute: 'TYP', label: 'Typ' },
      { attribute: 'KalkBestnr', label: 'Bokf.ordernr' },
      { attribute: 'TEXT', label: 'Rubrik' },
      { attribute: 'BESTALLD_DATUM', label: 'Beställd datum' },
      { attribute: 'ATTESTERAD_DATUM', label: 'Attesterad datum' },
      { attribute: 'AttestantFullnames', label: 'Attesteras av' },
      { attribute: 'BOKF_DATUM', label: 'Bokföringsdatum' },
      { attribute: 'STATUS', label: 'Status' },
    ],
    initialUrval: 'togzsULmBoixxupUavyPNYxzLzjTHxAH', // Standardurval: Att hantera
    onStartWarningHook: useBokforderOnStartWarningHook,
    showSelectionNameInList: true,
  },
  rtnEkonomiskAnalys: {
    component: EkonomiskAnalysPage,
    onStartWarningHook: useEkonomiskAnalysOnStartWarningHook,
    hideBreadcrumbs: true,
  },
  rtnAnalysutdelning: {
    component: pipe(
      withAddStartedRoutine(rutinInfos.rtnAnalysutdelning),
      withErrorBoundary(rutinInfos.rtnAnalysutdelning.benamning)
    )(AnalysutdelningPage),
  },
  rtnWebBudgetAskandemallar: {
    component: getStandardRutin(
      rutinInfos.rtnWebBudgetAskandemallar,
      'EKArbetsbudget'
    ),
    detaljVy: 'BudgetAskandemallar',
    directEditMode: true,
  },
};

export default EKRutiner;
